import axios from "axios"
import jwtDecode from "jwt-decode"
import { antiFraudSetting, apiWrapper } from "../configs"
import { JWT_TOKEN } from "../constants"
import { formatAntiFraudDate, getClientIp, getCookie, getDevicePayload } from "../helpers"
import { ANTI_FRAUD } from "../constants/antiFraud"
import apiClient from "../helpers/apiClient"

const apiCaller = axios.create({
	baseURL: apiWrapper,
	headers: {
		"x-issuer": "PORTAL",
	},
})

apiCaller.interceptors.response.use((res) => {
	res.data.payload = res.data.data
	return res
})

class Payment {
	get user() {
		const cookieToken = getCookie(JWT_TOKEN)
		return cookieToken ? jwtDecode(cookieToken) : {}
	}

	async getCardPaymentUrl(payload, config) {
		const { cardNo, amount, storedValueBalance } = payload

		let deviceBlackBox = window.collector.getPayload(window._bcn.dvc.getTID())
		deviceBlackBox = JSON.stringify(deviceBlackBox)
		const clientIp = await getClientIp()
		const res = await apiClient.post(
			"/api/card/create-web-order",
			{
				OrderCashAmount: amount,
				CardNo: cardNo,
				MemberId: this.user.member_id,
				MemberEmail: this.user.email,
				MemberName: this.user.given_name,
				ReceiveGatewayUrl: true,
				device: {
					endUserIp: clientIp,
					platform: ANTI_FRAUD.PLATFORM,
					appVersion: ANTI_FRAUD.APP_VERSION,
					blackBox: btoa(deviceBlackBox),
				},
			},
			config
		)
		getDevicePayload()

		res.data.payload = res.data.data // mapping data to payload for redux

		return res
	}

	async getEgiftPaymentUrl(payload, config) {
		const {
			amount,
			buyerName,
			buyerEmail,
			recipientName,
			recipientEmail,
			message,
			imageName,
			card,
		} = payload
		let deviceBlackBox = window.collector.getPayload(window._bcn.dvc.getTID())
		deviceBlackBox = JSON.stringify(deviceBlackBox)

		const clientIp = await getClientIp()

		const res = await apiClient.post(
			"/api/egift/create-web-order",
			{
				OrderCashAmount: amount,
				MemberId: this.user.member_id,
				MemberEmail: this.user.email,
				MemberName: this.user.given_name,
				ImageFullName: imageName,
				BuyerName: buyerName,
				BuyerEmail: buyerEmail,
				RecipientName: recipientName,
				RecipientEmail: recipientEmail,
				MessageForRecipient: message,
				ReceiveGatewayUrl: true,
				device: {
					endUserIp: clientIp,
					platform: ANTI_FRAUD.PLATFORM,
					appVersion: ANTI_FRAUD.APP_VERSION,
					blackBox: btoa(deviceBlackBox),
				},
				EgiftDetail: {
					lineItemNumber: 1,
					SKU: card.sku,
					description: card.itemTitle,
					category: card.category_Code,
					orderQuantity: 1,
				},
			},
			config
		)

		getDevicePayload()

		res.data.payload = res.data.data // mapping data to payload for redux

		return res
	}

	async verifyGatewayResponse(payload, config) {
		const res = await apiCaller.post(
			"ms-payment/api/payment/verify-gateway-response",
			payload,
			config
		)
		return res
	}

	async getEgiftRedemptionDynamicLink(cardNo, passcode, cardName, config = {}) {
		try {
			const res = await apiCaller.post(
				"ms-payment/api/egifts/redemption-dynamic-link",
				{
					CardNo: cardNo,
					Passcode: passcode,
					CardName: cardName,
				},
				config
			)
			return res.data.data.link
		} catch (error) {
			return null
		}
	}

	async getVoucherRedemptionDynamicLink(
		VoucherTypeName,
		ExpiryDate,
		TotalGifts,
		RecipientEmail,
		RedemptionPin,
		VoucherImageUrl,
		config = {}
	) {
		try {
			const res = await apiCaller.post(
				"ms-payment/api/voucher/redemption-dynamic-link",
				{
					VoucherTypeName: VoucherTypeName || "eGifting Voucher 1 Test",
					ExpiryDate,
					TotalGifts,
					RecipientEmail,
					RedemptionPin,
					VoucherImageUrl:
						VoucherImageUrl ||
						"https://edmsource.ascentismedia.com/uatresource/VoucherTypeImage/SBVN/eGiftVoucher1.jpg",
				},
				config
			)
			return res.data.data.link
		} catch (error) {
			return null
		}
	}
}

export const paymentService = new Payment()
